import container from "./container";

export default {
  Component: container,
};
